import { Routes, Route } from 'react-router-dom'
import { KaryvaWebsite } from './components/website/KaryvaWebsite'

function App() {
  return (
    <Routes>
      <Route path="/*" element={<KaryvaWebsite />} />
    </Routes>
  )
}

export default App
